import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./css/loader.css";
import "./css/asplan.css";
import '@fortawesome/fontawesome-free/css/all.min.css'

import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.min'
import 'admin-lte/dist/js/adminlte.min'



ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
